import i18n from "i18n";
import { banners } from "../banners.js";
export const getKrakowConfig = () => {
  return {
    cityOptions: {
      isInLocationsPage: true,
      isCityInProgress: false,
      title: "KRAKÓW",
      label: `${i18n.t("form.months.july")} 2025`,
      siteUrl: "/krakow",
      siteTitle: "Pixel XL Kraków",
      statue: "/documents/krakow/statue.pdf",
      nameKey: "krakow",
      newsletterCustomHeading: i18n.t("newsletterSection.customHeading"),
      buyTicketCustomHeading: i18n.t("shared.learnMore"),
      isPerformanceReviewEnabled: false,
    },
    mainSection: {
      isVisible: true,
      plan4uApiUrl: "https://xl.plan4u.pl/pixel/krakow/api/v1",
      youtubeBackgroundVideoID: "uOgvhlGtTMA",
      youtubeMobileBackgroundVideoID: "HxFrAfEqaHM",
    },
    aboutSection: {
      isVisible: true,
      aboutUsImages: [
        "/images/krakow/about-us/about-picture-1.png",
        "/images/poznan/about-us/about-picture-2.jpg",
        "/images/krakow/about-us/about-picture-2.png",
        "/images/poznan/about-us/about-picture-4.jpg",
        "/images/krakow/about-us/about-picture-3.png",
        "/images/poznan/about-us/about-picture-6.jpg",
      ],
      aboutUsMobileImages: [
        "/images/krakow/about-us/about-picture-1.png",
        "/images/poznan/about-us/about-picture-2.jpg",
        "/images/krakow/about-us/about-picture-2.png",
        "/images/poznan/about-us/about-picture-4.jpg",
        "/images/krakow/about-us/about-picture-3.png",
        "/images/poznan/about-us/about-picture-6.jpg",
      ],
    },
    priceSection: {
      isVisible: false,
      isCheckPricesButtonHidden: false,
      priceBanner: banners.price[35],
    },
    descriptionSection: {
      isVisible: true,
    },
    bookingSection: {
      isVisible: false,
      isBookLinkEnabled: false,
      bookingUrl: {
        eng: "https://xl.plan4u.pl/pixel/krakow/bookItNEW_EN.html",
        de: "https://xl.plan4u.pl/pixel/krakow/bookItNEW_DE.html",
        pl: "https://xl.plan4u.pl/pixel/krakow/bookItNEW_PL.html",
      },
      banners: banners.booking.poznan,
    },
    voucherSection: {
      voucherBanner: banners.voucher,
      isVisible: false,
      voucherPageUrl: "https://xl.plan4u.pl/pixel/krakow/getVoucher.html",
    },
    cooperationSection: {
      isVisible: true,
      isHrefEnabled: false,
      cooperationSectionVisibility: true,
      integrationOfferVisibility: true,
      birthdayOfferVisibility: true,
      schoolOfferVisibility: true,
    },
    reviewSection: {
      isVisible: false,
    },
    faqSection: {
      isVisible: true,
    },
    careerSection: {
      isVisible: false,
    },
    contactSection: {
      isVisible: true,
      isMapVisible: true,
      googleMapsOptions: {
        city: "Kraków",
        country: "Poland",
        street: "Lubicz 17a",
      },
      address: "Lubicz 17a, 31-503 Kraków",
      email: "krakow@pixel-xl.com",
    },
  };
};
